export default __webpack_public_path__ + "62578fa7016a84e92098ef0506f5f673.svg";